/* ============================================================
   Pholoh inline quick-add (ditch.la pattern).
   The size row is the control — one click on a size adds it.
   POST to /cart/add.js, then dispatch Impulse's own bubbling
   `ajaxProduct:added` event so theme.js's CartDrawer rebuilds + opens.
   No new drawer logic invented; no toggle state to manage.
   ============================================================ */
(function () {
  'use strict';

  function cartAddUrl() {
    return (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
  }

  function add(container, btn, variantId) {
    if (!container || container.dataset.loading === '1') return;
    var idInput = container.querySelector('[name="id"]');
    var id = variantId || (idInput && idInput.value);
    if (!id) return;
    if (idInput && variantId) idInput.value = variantId;

    container.dataset.loading = '1';
    if (btn) btn.classList.add('is-loading');

    var body = new FormData();
    body.append('id', id);
    body.append('quantity', 1);

    fetch(cartAddUrl(), {
      method: 'POST',
      body: body,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        container.dataset.loading = '';
        if (btn) btn.classList.remove('is-loading');
        if (data && (data.status === 422 || data.status === 'bad_request')) return;
        // Reuse Impulse's success path -> CartDrawer rebuild + open.
        container.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data, addToCartBtn: btn },
          bubbles: true
        }));
      })
      .catch(function () {
        container.dataset.loading = '';
        if (btn) btn.classList.remove('is-loading');
      });
  }

  /* Carousel drag-to-scroll the size row — POINTER events + pointer capture, so
     it behaves identically for mouse, touch and pen, and the capture isolates the
     drag from the rail behind it (the rail was stealing the gesture). A real drag
     suppresses the click so it doesn't add a size. CSS sets touch-action: pan-y,
     which routes horizontal gestures here while vertical still scrolls the page. */
  (function () {
    var row = null, startX = 0, startScroll = 0, dragging = false, captured = false, pid = null;
    var lastX = 0, lastT = 0, vel = 0, raf = 0;     // vel = px/ms (smoothed) for flick momentum
    function stopMomentum() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }
    document.addEventListener('pointerdown', function (e) {
      var r = e.target.closest('.pholoh-qa__sizes');
      if (!r) { row = null; return; }
      if (e.pointerType === 'mouse' && e.button !== 0) { row = null; return; }
      if (r.scrollWidth <= r.clientWidth + 1) { row = null; return; }  // nothing to scroll → taps work normally
      stopMomentum();                              // grabbing mid-glide stops it
      // DON'T capture yet — a plain tap must stay a click so it selects the size.
      row = r; dragging = false; captured = false; pid = e.pointerId;
      startX = e.clientX; startScroll = r.scrollLeft;
      lastX = e.clientX; lastT = e.timeStamp; vel = 0;
    });
    document.addEventListener('pointermove', function (e) {
      if (!row || e.pointerId !== pid) return;
      var dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < 6) return;          // below threshold → still a potential tap
        dragging = true; row.classList.add('is-dragging');
        try { row.setPointerCapture(pid); captured = true; } catch (x) {}  // capture only once it's a real drag
      }
      row.scrollLeft = startScroll - dx;
      var dt = e.timeStamp - lastT;            // track release velocity (smoothed)
      if (dt > 0) { vel = vel * 0.7 + ((e.clientX - lastX) / dt) * 0.3; lastX = e.clientX; lastT = e.timeStamp; }
      if (e.cancelable) e.preventDefault();
    });
    function end(e) {
      if (!row) return;
      var r = row;
      if (captured && pid != null) { try { r.releasePointerCapture(pid); } catch (x) {} }
      r.classList.remove('is-dragging');
      if (dragging) {
        r.dataset.dragged = '1'; setTimeout(function () { r.dataset.dragged = ''; }, 60);
        // flick momentum: if released while still moving, keep gliding and decelerate
        var idle = (e && e.timeStamp ? e.timeStamp : lastT) - lastT;
        var v = (idle < 90 ? vel : 0) * 16;    // px per ~16ms frame
        v = Math.max(-60, Math.min(60, v));    // cap runaway flicks
        var max = r.scrollWidth - r.clientWidth;
        if (Math.abs(v) > 1) {
          (function glide() {
            r.scrollLeft -= v;
            v *= 0.94;                          // friction
            if (Math.abs(v) > 0.4 && r.scrollLeft > 0 && r.scrollLeft < max) {
              raf = requestAnimationFrame(glide);
            } else { raf = 0; }
          })();
        }
      }
      row = null; pid = null; dragging = false; captured = false;
    }
    document.addEventListener('pointerup', end);
    document.addEventListener('pointercancel', end);
  })();

  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('.pholoh-qa__size');
    if (sizeBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (sizeBtn.hasAttribute('disabled')) return;
      var dragRow = sizeBtn.closest('.pholoh-qa__sizes');
      if (dragRow && dragRow.dataset.dragged === '1') return; // it was a drag, not a tap
      add(sizeBtn.closest('.pholoh-qa'), sizeBtn, sizeBtn.dataset.variantId);
      return;
    }
    var addBtn = e.target.closest('.pholoh-qa__add, [data-pholoh-qa-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      add(addBtn.closest('.pholoh-qa'), addBtn, null);
    }
  });

})();

/* ------------------------------------------------------------------
   Drag-to-scroll for horizontal product rails (desktop mouse).
   Click + hold + slide to pan the rail; a real drag suppresses the
   trailing click so you don't open a product by accident. Touch uses
   native scrolling and is untouched.
   ------------------------------------------------------------------ */
(function () {
  function enableDrag(el) {
    var down = false, startX = 0, startScroll = 0, moved = false;
    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      if (e.target.closest('.pholoh-qa')) return;   // size box scrolls itself — don't drag the rail
      down = true; moved = false;
      startX = e.pageX; startScroll = el.scrollLeft;
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false; el.classList.remove('is-dragging');
    });
    el.addEventListener('mouseleave', function () {
      down = false; el.classList.remove('is-dragging');
    });
    el.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (!moved && Math.abs(dx) > 4) { moved = true; el.classList.add('is-dragging'); }
      if (moved) { el.scrollLeft = startScroll - dx; e.preventDefault(); }
    });
    // swallow the click that ends a drag (capture phase, before card/size handlers)
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }
  // Scroll-progress bar: thumb width = visible/total, position tracks scrollLeft.
  function wireProgress(el) {
    var bar = el.parentElement && el.parentElement.querySelector('.pholoh-railbar');
    var thumb = bar && bar.querySelector('.pholoh-railbar__thumb');
    if (!thumb) return;
    var raf = 0;
    function paint() {
      raf = 0;
      var sw = el.scrollWidth, cw = el.clientWidth;
      if (sw <= cw + 2) { bar.style.display = 'none'; return; }
      bar.style.display = '';
      // fill from the left = how much of the rail has been viewed (scrolled past + visible)
      var viewed = (el.scrollLeft + cw) / sw;
      thumb.style.width = Math.max(0, Math.min(viewed * 100, 100)) + '%';
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(paint); }
    el.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    paint();
  }
  function init() {
    document.querySelectorAll('.grid-overflow-wrapper').forEach(function (el) {
      if (el.dataset.pholohDrag) return;
      el.dataset.pholohDrag = '1';
      enableDrag(el);
      wireProgress(el);
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ------------------------------------------------------------------
   Cart-drawer upsell ("Complete the look") — clean swipe carousel + dots.
   - The size <select> swaps which variant the "Add to bag" link targets.
   - Dots reflect the active card; clicking a dot scrolls to that card.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  // size select -> add link variant
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.pholoh-upsell__select');
    if (!sel) return;
    var card = sel.closest('.pholoh-upsell__card');
    var add = card && card.querySelector('.pholoh-upsell__add');
    if (add && sel.value) add.setAttribute('data-variant-id', sel.value);
  });

  function upsell() { return document.querySelector('[data-pholoh-upsell]'); }
  function strip() { return document.querySelector('[data-upsell-strip]'); }

  // clicking a dot scrolls to that card
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-upsell-dot]');
    if (!dot) return;
    var s = strip();
    if (!s) return;
    var i = parseInt(dot.getAttribute('data-upsell-dot'), 10) || 0;
    s.scrollTo({ left: s.clientWidth * i, behavior: 'smooth' });
  });

  // active dot follows the scroll position
  function syncDots() {
    var s = strip();
    var box = upsell();
    if (!s || !box) return;
    var dots = box.querySelectorAll('[data-upsell-dot]');
    if (!dots.length) return;
    var idx = Math.round(s.scrollLeft / s.clientWidth);
    dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
  }
  var raf = 0;
  document.addEventListener('scroll', function (e) {
    if (!e.target.closest || !e.target.closest('[data-upsell-strip]')) return;
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; syncDots(); });
  }, true);

  // NOTE: the auto-advance carousel was removed. It scrolled the "Complete the look"
  // strip one panel every few seconds while the drawer was open, which moved the size
  // buttons out from under the shopper mid-tap — taps missed, landed on empty space, and
  // the cart felt un-interactive (especially on the auto-open right after add-to-cart).
  // The strip is now a plain swipeable row (native touch scroll + desktop drag), so the
  // shirts stay put and every size button is reliably tappable. Function > flourish.
})();
